// extracted by mini-css-extract-plugin
export var images = "_6l-0";
export var link = "_6l-1";
export var pillContent = "_6l-2";
export var pillIcon = "_6l-3";
export var salesChannelWrapper = "_6l-4";
export var section = "_6l-5";